import axios from 'axios';
// NOTE: 과거 axios-case-converter 로 요청 파라미터를 camelCase -> snake_case 변환했으나
// 서버가 camelCase 를 기대하여 해제했다. 의존성도 제거된 상태다.
// 응답 방향의 snake_case -> camelCase 변환은 services/axiosInterceptor.ts 의
// responseInterceptor(humps camelizeKeys)가 담당한다.

const config = {
  headers: {
    // "api-version": "2.0", // TODO 확인 필요
    // "x-content-case": "Camel",
  },
};

export const PATH = '/api/PCS';

export default axios.create(config);
